module.exports = __webpack_public_path__ + "static/media/drop-10@2x.86ec4b10.png";